import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { RoleType } from '../../../types';

interface InviteGetStartedProps {
  type: RoleType;
  inputs: any;
  customerId: string;
}

export const useGetStarted = () =>
  useMutation('useMutation', async ({ inputs, customerId, type }: InviteGetStartedProps) =>
    httpService.put(`${BASE_URL}/api/v1/user/${customerId}/authorized/user/start`, {
      ...inputs,
      type,
      accepted: true,
    }));
